import React, {useEffect, useState} from "react";
import {ActionButton} from "../components/buttons";
import DynamicTable from "../components/DynamicTable";
import {columns} from "../helpers/tableData";
import {CommonModal} from "../dialogs";
import {useDispatch} from "react-redux";
import {usePagination} from "../hooks";
import {$crud} from "../services/CrudFactory";
import {ConfirmationModal} from "../dialogs/ConfirmationModal";
import Typography from "@mui/material/Typography";

export const Universities = () =>{
    const dispatch = useDispatch();
    const [status, setStatus] = useState(null);
    const [idToRemove, setIdToRemove] = useState(null);
    const [universities, setUniversities] = useState([]);
    const {limit, setLimit, page, setPage, total, setTotal} = usePagination();

    const statusChange=async (id) => {
        try {
            dispatch({
                type: "LOADER",
                loader: true
            });
            const {type, message} = await $crud.post("create/web/status/statuses", {
                id
            });
            retrieveUniversities().then(res => {
                setUniversities(res.boardAndUniversities);
            });
            dispatch({
                type: "SNACKBAR",
                snackBar: {type, message}
            });
        } catch (e) {
            dispatch({
                type: "SNACKBAR",
                snackBar: {type: "error", message: e.message}
            });
        } finally {
            dispatch({
                type: "LOADER",
                loader: false
            });
        }
    };

    const retrieveUniversities=async () => {
        try {
            dispatch({
                type: "LOADER",
                loader: true
            });
            const {data } = await $crud.retrieve("web/board-and-universities",{limit,page});
            return data;
        } catch (e) {
            dispatch({
                type: "SNACKBAR",
                snackBar: {type: "error", message: e.message}
            });
        } finally {
            dispatch({
                type: "LOADER",
                loader: false
            });
        }
    };
    const remove = async(id)=>{
        try {
            dispatch({
                type: "LOADER",
                loader: true
            });
            const {type, message } = await $crud.post("delete/web/board-and-university",{id});
            dispatch({
                type: "SNACKBAR",
                snackBar: {type, message}
            });
            retrieveUniversities().then(res=> {
                setUniversities(res.boardAndUniversities);
                setTotal(res.total);
            });
            setIdToRemove(null);
        } catch (e) {
            dispatch({
                type: "SNACKBAR",
                snackBar: {type: "error", message: e.message}
            });
        } finally {
            dispatch({
                type: "LOADER",
                loader: false
            });
        }
    };
    useEffect(()=>{
        retrieveUniversities().then(res=> {
            setUniversities(res.boardAndUniversities);
            setTotal(res.total);
        });
    },[limit, page]);
    return (
        <>
            <div>
                <div className='row w-100 g-2'>
                    <div className='mb-3 d-flex'>
                        <ActionButton onClick={() => setStatus({})} buttonName="Add University"/>
                    </div>
                </div>
            </div>
            <DynamicTable
                rows={universities}
                columns={columns?.universities}
                style={{maxHeight: "calc(100vh - 102px)"}}
                total={total}
                onRowClick={() => {
                }}
                onStatusChange={(id) => {
                    statusChange(id);
                }}
                onDelete={(id)=>setIdToRemove(id)}
                onEdit={(value) => {
                    setStatus(value);
                }}
                paginationProps={{
                    limit: limit,
                    page: page,
                    onChangeLimit: (limit) => setLimit(limit),
                    onChangePage: (page) => setPage(page),
                }}
            />
            <CommonModal
                onSave={() => {
                    retrieveUniversities().then(res=> {
                        setUniversities(res.boardAndUniversities);
                        setTotal(res.total);
                    });
                }}
                title="University"
                apiUrl="web/board-and-university"
                data={status}
                onClose={() => setStatus(null)}
                open={!!status}
            />
            <ConfirmationModal
                open={!!idToRemove}
                title="Remove University"
                content={
                    <>
                        <Typography variant="subtitle1" >Removing Universities may lead to
                            Data Insufficiency In Lead | Make Sure to assign
                            Another University Ids To These  Leads.</Typography>
                        <Typography variant="subtitle2" > Press &apos;Yes&apos; To Remove
                            anyway.</Typography>
                    </>
                }
                onClose={() => {
                    setIdToRemove(null);
                }}
                onOk={() => remove(idToRemove)}
            />
        </>
    );
};